// Single source of truth for identifying predictive-scoring socket notifications.
// Shared by the growl formatter (PredictiveScoringFormatter), the global growl triggers
// (SocketGrowlTriggers), and the creatives grid refresh (routes/creatives/Grid), so the
// task-matching logic only has to change in one place.

export const SCORING_COMPLETE_TASK = "Predictive Scoring Complete";
export const SCORING_PARTIAL_TASK = "Predictive Scoring Partial";
export const SCORING_FAILED_TASK = "Predictive Scoring Failed";

export const SCORING_FAILED_FALLBACK_MESSAGE = "Scoring failed. Please try again.";

// Case-insensitive + anchored, matching the regex the grid and growl triggers already used.
const SCORING_TASK_REGEXP = /^Predictive Scoring (Complete|Partial|Failed)$/i;

export function isPredictiveScoringTask(task) {
	return SCORING_TASK_REGEXP.test(task || "");
}

export function isPartialScoringTask(task) {
	return /partial/i.test(task || "");
}

export function isFailedScoringTask(task) {
	return /failed/i.test(task || "");
}
